(() => {
  // Läuft wiederholt, bis Probo die Übersicht gerendert hat
  function cleanupOnce(root) {
    if (!root) return;

    // In der Übersicht gibt es mehrere "Karten" (Boxen)
    const cards = root.querySelectorAll('nav [class*="border"], nav [class*="rounded"]');
    if (!cards.length) return;

    cards.forEach(card => {
      // Jede Zeile ist bei Probo meist: <div class="flex gap-2"> <span class="font-semibold">Breite:</span> <span>100</span> <span>cm</span> ...
      const rows = card.querySelectorAll('.flex.gap-2');
      if (!rows.length) return;

      let widthRow = null;
      let heightRow = null;

      rows.forEach(r => {
        const labelEl = r.querySelector('.font-semibold');
        if (!labelEl) return;

        const label = (labelEl.textContent || '').trim().toLowerCase();
        if (label.includes('breite')) widthRow = r;
        if (label.includes('höhe')) heightRow = r;
      });

      // Wenn in dieser Karte keine Breite/Höhe existiert -> nicht anfassen
      if (!widthRow || !heightRow) return;

      // Werte auslesen: wir nehmen den Text der gesamten Zeile und ziehen die Zahl raus
      const wText = widthRow.textContent || '';
      const hText = heightRow.textContent || '';

      const wMatch = wText.match(/breite:\s*([0-9]+([.,][0-9]+)?)/i);
      const hMatch = hText.match(/höhe:\s*([0-9]+([.,][0-9]+)?)/i);

      if (!wMatch || !hMatch) return;

      const w = wMatch[1];
      const h = hMatch[1];

      // Breite-Zeile zu "Format: W × H cm" umbauen
      const labelEl = widthRow.querySelector('.font-semibold');
      if (!labelEl) return;

      // Alles außer Label entfernen
      widthRow.querySelectorAll('span').forEach((sp, idx) => {
        if (idx !== 0) sp.remove();
      });

      // Label ändern
      labelEl.textContent = 'Format (BxH):';

      // Wert einsetzen
      const valueSpan = document.createElement('span');
      valueSpan.textContent = `${w} × ${h} cm`;
      valueSpan.style.fontWeight = '400'; // NICHT fett
      valueSpan.style.marginLeft = '6px';
      valueSpan.style.color = 'inherit';
      widthRow.appendChild(valueSpan);

      // Höhe-Zeile entfernen
      heightRow.remove();
    });
  }

  function start() {
    const root = document.querySelector('#root');
    if (!root) return;

    // 1) sofort versuchen
    cleanupOnce(root);

    // 2) beobachten, weil Probo nachlädt / neu rendert
    const obs = new MutationObserver(() => cleanupOnce(root));
    obs.observe(root, { childList: true, subtree: true });
  }

  // sicher starten
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
